export const FIRST_LAZY_LOAD_INDEX_IN_PAGE = 4
export const LANDINGS_BASE_PATHNAME = '/landing'

export const NO_INDEX_SLUGS = ['sunscreen', 'anxiety', 'serum']

export const HOMEPAGE_VIDEO_SLUG = 'homepage'
